import { IStandardSignatureLines } from 'Modules/Communication/shared/models/Signature'

export const getStandardSignature = (
  lines?: IStandardSignatureLines,
  anonymous?: boolean
) => {
  if (!lines) return ''
  const p1 = `<p>Med vennlig hilsen</p>`
  const p2 = `<strong>${anonymous ? 'Navn' : lines.userFullName}</strong>`
  const p3 =
    (lines.userBoardMemberFunction &&
      `<br/><i>${anonymous ? 'Rolle' : lines.userBoardMemberFunction}</i>`) ||
    ''
  return `<div class="standard-signature">${p1}${p2}${p3}</div>`
}

export const getFullSignature = (
  lines?: IStandardSignatureLines,
  signature?: string,
  anonymous?: boolean
) => {
  if (!lines) return ''
  return `${getStandardSignature(lines, anonymous)}${
    signature ? `<br /><div class="signature">${signature}</div>` : ''
  }`
}

export const getSmsSignature = (role: string, fullName: string) =>
  `\n\nMvh ${fullName}\n${role || ''}`
